var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.5 10.2375L10.2375 7.5L7.5 4.7625L6.7125 5.55L8.1 6.9375H4.6875V8.0625H8.1L6.7125 9.45L7.5 10.2375ZM7.5 15C6.475 15 5.50625 14.8031 4.59375 14.4094C3.68125 14.0156 2.88438 13.4781 2.20312 12.7969C1.52188 12.1156 0.984375 11.3188 0.590625 10.4062C0.196875 9.49375 0 8.525 0 7.5C0 6.4625 0.196875 5.4875 0.590625 4.575C0.984375 3.6625 1.52188 2.86875 2.20312 2.19375C2.88438 1.51875 3.68125 0.984375 4.59375 0.590625C5.50625 0.196875 6.475 0 7.5 0C8.5375 0 9.5125 0.196875 10.425 0.590625C11.3375 0.984375 12.1313 1.51875 12.8063 2.19375C13.4813 2.86875 14.0156 3.6625 14.4094 4.575C14.8031 5.4875 15 6.4625 15 7.5C15 8.525 14.8031 9.49375 14.4094 10.4062C14.0156 11.3188 13.4813 12.1156 12.8063 12.7969C12.1313 13.4781 11.3375 14.0156 10.425 14.4094C9.5125 14.8031 8.5375 15 7.5 15ZM7.5 13.875C9.275 13.875 10.7812 13.2531 12.0187 12.0094C13.2562 10.7656 13.875 9.2625 13.875 7.5C13.875 5.725 13.2562 4.21875 12.0187 2.98125C10.7812 1.74375 9.275 1.125 7.5 1.125C5.7375 1.125 4.23438 1.74375 2.99062 2.98125C1.74687 4.21875 1.125 5.725 1.125 7.5C1.125 9.2625 1.74687 10.7656 2.99062 12.0094C4.23438 13.2531 5.7375 13.875 7.5 13.875Z",
    fill: "#5E5E5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightCircle);
export default __webpack_public_path__ + "static/media/arrow-right-circle.c2808d002878ad1cd9a3e2ec3f7dbe51.svg";
export { ForwardRef as ReactComponent };